<template>
    <va-edit-layout>
        <Order-form :id="id" :title="title" :item="item"></Order-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
